import { useGetUserTests } from '../../../../services/userTest';
import { ResultBox } from '../ResultBox';
import { Skeleton } from 'antd';
import clsx from 'clsx';

import './TestResults.scss';

const TestResults = () => {
  const { loading, userTests } = useGetUserTests();

  if (loading) {
    return (
      <div className='result-content'>
        {[1, 2, 3].map((index) => (
          <div
            key={index}
            className={clsx(
              'relative overflow-hidden rounded-lg border transition-all duration-300 mb-2',
              'p-2 md:p-3',
              'flex items-center justify-between gap-3',
              // Light mode
              'bg-white border-gray-200 shadow-sm',
              // Dark mode
              'dark:bg-surface-dark dark:border-borders dark:shadow-lg'
            )}
          >
            {/* Status indicator bar skeleton */}
            <div className={clsx(
              'absolute left-0 top-0 bottom-0 w-1',
              'bg-gray-200 dark:bg-surface-medium'
            )} />

            {/* Icon and title section */}
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <Skeleton.Avatar
                active
                size={32}
                shape="square"
                className="flex-shrink-0 rounded-lg"
              />
              <div className="flex-1 min-w-0">
                <Skeleton
                  active
                  title={{ width: '60%' }}
                  paragraph={{ rows: 2, width: ['100%', '40%'] }}
                />
              </div>
            </div>

            {/* Results section skeleton */}
            <div className="flex items-center gap-3 flex-shrink-0">
              <Skeleton
                active
                title={{ width: 60 }}
                paragraph={false}
              />
              <Skeleton.Button
                active
                size="small"
                style={{ width: 80, height: 24 }}
              />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className='result-content'>
      {userTests && userTests.length > 0 && userTests?.map((userTest) =>
        <ResultBox key={userTest._id} result={userTest} />
      )}
    </div>
  );
};

export { TestResults };
